import { awsApiInstance } from '../api/aws-api';

import { IPostPinPool, IPostPinPoolResponse } from "../models/cardgroup.interface";
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts new Pin Pool data to AWS
 * 
 * @param {IPostPinPool} pinPool the pin pool data
 * 
 * @returns {IPostPinPool} the api response | error
 */
const PostPinPool = async (pinPool: IPostPinPool): Promise<IPostPinPoolResponse> => {
  try {
    const { data } = await awsApiInstance.post(`/card-group/${pinPool.cardGroupId}/pin-pool`, pinPool);

    return data;
  } catch (error) {
    handleRouteError(error, 'Error updating pin pool');
    throw(error);
  }
}

export default PostPinPool;